import * as fromDatatype from '../datatype-library'

export interface bl_asv_consultation_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_branch:  fromDatatype.GuidDataFieldInterface;
    vehicle_hdr_guid:  fromDatatype.GuidDataFieldInterface;
    vehicle_registration_no:fromDatatype.VarcharDatatypeInterface;
    consultation_running_no:fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    consultant_guid: fromDatatype.GuidDataFieldInterface;
    member_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_entity_hdr_json:fromDatatype.JsonDatatypeInterface;
    billing_json:fromDatatype.JsonDatatypeInterface;
    delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
    delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    server_doc_6: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_2: fromDatatype.VarcharDatatypeInterface;
    client_doc_3: fromDatatype.VarcharDatatypeInterface;
    client_doc_4: fromDatatype.VarcharDatatypeInterface;
    client_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    guid_comp:fromDatatype.GuidDataFieldInterface;
    doc_source_type: fromDatatype.VarcharDatatypeInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    code_company:fromDatatype.VarcharDatatypeInterface;
    code_branch:fromDatatype.VarcharDatatypeInterface;
    code_location:fromDatatype.VarcharDatatypeInterface;
    einvoice_self_billed:fromDatatype.VarcharDatatypeInterface;
    original_einvoice_ref_no:fromDatatype.VarcharDatatypeInterface;
    einvoice_shipping_entity_json:fromDatatype.JsonDatatypeInterface;
    delivery_entity_json:fromDatatype.JsonDatatypeInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;

}

export class bl_asv_consultation_hdr_RowClass implements bl_asv_consultation_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_branch:  fromDatatype.GuidDataFieldInterface;
    vehicle_hdr_guid:  fromDatatype.GuidDataFieldInterface;
    vehicle_registration_no:fromDatatype.VarcharDatatypeInterface;
    consultation_running_no:fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    consultant_guid: fromDatatype.GuidDataFieldInterface;
    member_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_entity_hdr_json:fromDatatype.JsonDatatypeInterface;
    billing_json:fromDatatype.JsonDatatypeInterface;
    delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
    delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_2: fromDatatype.VarcharDatatypeInterface;
    server_doc_3: fromDatatype.VarcharDatatypeInterface;
    server_doc_4: fromDatatype.VarcharDatatypeInterface;
    server_doc_5: fromDatatype.VarcharDatatypeInterface;
    server_doc_6: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_2: fromDatatype.VarcharDatatypeInterface;
    client_doc_3: fromDatatype.VarcharDatatypeInterface;
    client_doc_4: fromDatatype.VarcharDatatypeInterface;
    client_doc_5: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    guid_comp:fromDatatype.GuidDataFieldInterface;
    doc_source_type: fromDatatype.VarcharDatatypeInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    code_company:fromDatatype.VarcharDatatypeInterface;
    code_branch:fromDatatype.VarcharDatatypeInterface;
    code_location:fromDatatype.VarcharDatatypeInterface;
    einvoice_self_billed:fromDatatype.VarcharDatatypeInterface;
    original_einvoice_ref_no:fromDatatype.VarcharDatatypeInterface;
    einvoice_shipping_entity_json:fromDatatype.JsonDatatypeInterface;
    delivery_entity_json:fromDatatype.JsonDatatypeInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}